import schedulesViewStateStore from "../../store/store";
import { mutatorAction } from "satcheljs";

export default mutatorAction("SET_SHOW_FILTER_ERROR", function setShowFilterError(
    showFilterError: boolean
) {
    schedulesViewStateStore().showFilterError = showFilterError;
});
